import { React, Fragment, useState } from "react";
import Contactbanner from "../../assets/images/blog-img3.jpg";
import { FaArrowRight, FaSearch } from "react-icons/fa";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import BlogCards from "../Blogs/BlogCards";
import blog1 from "../../assets/images/developers-working-on-desktop.avif";
import blog2 from "../../assets/images/blog-img2.jpg";
import blog3 from "../../assets/images/blog-img3.jpg";
import blog4 from "../../assets/images/blog-img4.jpg";
import blogDes1 from "../../assets/images/blog-des-1.jpg";
import blogDes2 from "../../assets/images/blog-des-2.jpg";
import blogDes3 from "../../assets/images/blog-des-3.jpg";
import CustomBanner from "../../components/CustomBanner";
import EmailComponent from "../../components/EmailComponent";
import { motion } from "framer-motion";
import { Head } from "vite-react-ssg";
import AuthorLayout from "./components/AuthorLayout";

function Blog1DescriptionPage() {
  const blogData = [
    {
      image: blog1,
      title: "Crafting Seamless Web and Mobile Experiences",
      desc: "Discover how modern apps are built to work flawlessly across all platforms.",
      date: "January 15, 2025",
      time: "3min",
    },
    {
      image: blog2,
      title: "Transforming Ideas into Scalable Digital Solutions",
      desc: "We turn your concepts into enterprise-grade applications that grow with your business.",
      date: "February 5, 2025",
      time: "4min",
    },
    {
      image: blog3,
      title: "Driving Innovation in Mobile & Web Development",
      desc: "Explore the cutting-edge tools that are changing the digital landscape.",
      date: "March 12, 2025",
      time: "5min",
    },
    {
      image: blog4,
      title: "Revolutionizing E-commerce Through Custom Platforms",
      desc: "Create personalized shopping experiences with our tailored e-commerce solutions.",
      date: "March 28, 2025",
      time: "2min",
    },
    {
      image: blog2,
      title: "Boosting Business with Cloud-Powered Apps",
      desc: "How cloud technology can scale your business operations efficiently.",
      date: "April 8, 2025",
      time: "4min",
    },
    {
      image: blog3,
      title: "Design-Driven Development for Maximum Impact",
      desc: "Merging UI/UX design with solid development for powerful user engagement.",
      date: "April 20, 2025",
      time: "3min",
    },
    {
      image: blog1,
      title: "Why Mobile-First Strategy Matters in 2025",
      desc: "Understanding the importance of prioritizing mobile in your tech roadmap.",
      date: "May 2, 2025",
      time: "3min",
    },
    {
      image: blog4,
      title: "The Future of IoT and Smart Applications",
      desc: "Take a look into how IoT is transforming daily life and industries.",
      date: "May 19, 2025",
      time: "5min",
    },
    {
      image: blog3,
      title: "Agile Development: Benefits for Fast-Growing Startups",
      desc: "How startups are leveraging agile methodologies for rapid product evolution.",
      date: "June 1, 2025",
      time: "2min",
    },
    {
      image: blog1,
      title: "Top UI/UX Trends You Can’t Ignore This Year",
      desc: "From neomorphism to minimalist design — stay ahead of the design curve.",
      date: "June 10, 2025",
      time: "4min",
    },
  ]; 

  return (
    <Fragment>
      <Head>
        <title>We’re thrilled to introduce our new website</title>
        <meta
          name="description"
          content="Launched in style, explore our website and see what we’re all about."
        />
        <link
          rel="canonical"
          href="https://apptalyst.com/welcome-to-our-new-site "
        />
      </Head>
      <CustomBanner mobileFullScreenHeight={false}>
        <time className="text-xl md:text-2xl font-bold">April 3, 2025</time>
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
          className="text-[30px] md:text-[38px] lg:text-[47px] xl:text-[52px] 2xl:text-[67px] leading-[1]  font-bold "
        >
          Welcome to our new site Apptalyst.com!{" "}
        </motion.h1>

        {/* <div className="py-2">
          <div className="text-white   text-xl md:text-2xl font-bold">
            Affan
          </div>
          <div className="text-white text-xl md:text-2xl  font-bold">
            Chief Technology Officer
          </div>
        </div> */}
      </CustomBanner>

      <div className="bg-gray-50">
        <div className="container">
          <div className=" py-20 px-4 space-y-10 ">

          <section >
            <div className="space-y-5">
              <p className="text-base leading-[1.625rem] text-dark ">
                We’re thrilled to introduce Apptalyst.com, your new go-to for
                high-performance digital solutions. Our website is built to be
                fast, sleek, and just as friendly as we are.
              </p>
              <motion.h2
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="text-2xl md:text-3xl mt-10 capitalize text-dark"
              >
                What We’re All About
              </motion.h2>

              <p className="text-base leading-[1.625rem]  text-dark">
                We specialize in tailor-made digital solutions to bring your
                ideas to life. Our services include:
              </p>
              <ul className="text-base md:text-lg  text-dark list-disc list-inside pl-2 md:pl-6 space-y-3 md:space-y-6">
                 <li className="text-base leading-[1.625rem] ">
                  <h3 className="text-base md:text-lg  text-dark font-bold inline">
                    Cross-platform and Native Mobile Apps{" "}
                  </h3>
                  engineered for performance and reliability.
                </li>
                <li className="text-base leading-[1.625rem] ">
                  <h3 className="text-base md:text-lg  text-dark font-bold inline">
                    Web Applications{" "}
                  </h3>
                   that are robust and yet feel effortless.
                </li>
                <li className="text-base leading-[1.625rem] ">
                  <h3 className="text-base md:text-lg  text-dark font-bold inline">
                    IoT Solutions {""}
                  </h3>
                  that catalyze innovation for a smarter, connected world.
                </li>
                <li className="text-base leading-[1.625rem] ">
                  <h3 className="text-base md:text-lg  text-dark font-bold inline">
                    CMS Development{" "}
                  </h3>
                    to put you in control of your websites.
                </li>
                <li className="text-base leading-[1.625rem] ">
                  <h3 className="text-base md:text-lg  text-dark font-bold inline">
                    UI/UX Design{" "}
                  </h3>
                     that is professional and delights users.
                </li>
                <li className="text-base leading-[1.625rem] ">
                  <h3 className="text-base md:text-lg  text-dark font-bold inline">
                    Digital Marketing{" "}
                  </h3>
                    to make sure you’re seen.
                </li>
                 
              </ul>

              <div className="w-full md:w-[60%] mx-auto">
                <img
                  src={blog1}
                  alt="Developers working on their desktop PCs in office, with code displayed on their screens."
                  className=" w-full"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="space-y-5">
              <motion.h2
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="text-2xl md:text-3xl mt-10   text-dark"
              >
                Behind the Scenes
              </motion.h2>
              <p className="text-base leading-[1.625rem]   text-dark ">
                Launching a new site is a bit like hosting a backyard barbecue
                where you want everything to be just right for your guests.
                That’s why we built Apptalyst.com as a lightning-fast Single
                Page Application (SPA) using React and Vite, ensuring
                buttery-smooth experience whether you’re browsing on a phone,
                tablet, or desktop.
              </p>
              <p className="text-base leading-[1.625rem] text-dark">
                By leveraging Static Site Generation (SSG), we’ve baked in SEO
                best practices from the ground up. So when you’re searching for
                a top-notch development partner, we’re easy to find.
              </p>
              <p className="text-base leading-[1.625rem] text-dark">
                While we won’t geek out too much, here’s what makes this site
                tick:
              </p>
              <ul className="text-dark list-disc list-inside pl-2 md:pl-6 space-y-3 md:space-y-6">
                <li className="text-base leading-[1.625rem] ">
                  <h3 className="text-base md:text-lg  text-dark font-bold inline">
                    Built for speed:{" "}
                  </h3>
                  React + Vite means near-instant loading (no more staring at
                  spinners).
                </li>
                <li className="text-base leading-[1.625rem] ">
                  <h3 className="text-base md:text-lg  text-dark font-bold inline">
                    Mobile-friendly:{" "}
                  </h3>
                  Looks sharp on your pocket devices.
                </li>
                <li className="text-base leading-[1.625rem] ">
                  <h3 className="text-base md:text-lg  text-dark font-bold inline">
                    Easy to explore:{" "}
                  </h3>
                  Simple navigation, so you spend less time clicking and more
                  time discovering.
                </li>
                 
              </ul>
            </div>
            <div className="space-y-5">
              <motion.h2
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="text-2xl md:text-3xl mt-10   text-dark"
              >
                We’re More Than Just a Pretty Site
              </motion.h2>
              <p className="text-base leading-[1.625rem] text-dark ">
                This launch is just the beginning. We’re committed to:
              </p>
              <ul className="text-base md:text-lg  text-dark list-disc list-inside pl-2 md:pl-6 space-y-3 md:space-y-6">
                <li className="text-base leading-[1.625rem]">
                  <h3 className="text-base md:text-lg  text-dark font-bold inline">
                    Transparency:{" "}
                  </h3>
                  No jargon-filled runarounds, just straight talk about what we
                  can do for you.
                </li>
                <li className="text-base leading-[1.625rem]">
                  <h3 className="text-base md:text-lg  text-dark font-bold inline">
                    Community:{" "}
                  </h3>
                  Follow us on our socials for tips, updates, and maybe a meme
                  or two.
                </li>
                <li className="text-base leading-[1.625rem]">
                  <h3 className="text-base md:text-lg  text-dark font-bold inline">
                    Growth:{" "}
                  </h3>
                  We’ll keep refining and adding features based on your
                  feedback.
                </li>
                 
              </ul>
            </div>
            <div className="space-y-5">
              <motion.h2
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="text-2xl md:text-3xl mt-10 capitalize text-dark"
              >
                Come On In!
              </motion.h2>
              <p className="text-base leading-[1.625rem]  text-dark ">
                Take a look around, and if you like what you see… let’s chat.
                Whether you’re local to Virginia or halfway across the globe,
                we’re here to help you build something extraordinary.
              </p>
              <div>
                <p className="text-base md:text-lg  text-dark">
                  <i>Proudly designed and developed by</i>
                </p>
                <p className="text-base md:text-lg  text-dark">
                  <i> - The Apptalyst Team</i>
                </p>
              </div>
            </div>
          </section>

           <AuthorLayout/>
          </div>

        </div>
        {/* <section className="max-w-full sm:max-w-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl  2xl:max-w-screen2xl mx-auto py-20 px-4  ">
          <h1 className="text-5xl my-20">You might also like</h1>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-20 gap-y-10  ">
            {blogData.slice(0, 3).map((blog, index) => (
              <div
                key={index}
                className="w-[100%] rounded-3xl overflow-hidden shadow-xl"
              >
                <div>
                  <img
                    src={blog.image}
                    alt=""
                    className="object-cover w-full h-full"
                    loading="lazy"
                  />
                </div>
                <div className="px-8 py-5 space-y-5 ">
                  <div className="text-[#343434]">
                    <h1 className="text-2xl font-bold">{blog.title}</h1>
                  </div>
                  <div className="flex justify-between items-center text-xs border-t border-[#F7F7F7] pt-3 align-bottom">
                    <div className="w-2/6 border-r border-[#CECECE] text-sm capitalize">
                      {blog.date.split(",")[0]},{" "}
                      <div>{blog.date.split(",")[1]}</div>
                    </div>
                    <div className="w-5/6 flex justify-between text-[#6D1349] font-bold">
                      <div className="pl-4">{blog.time}</div>
                      <div>
                        <FaArrowRight className="text-[#6D1349]" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section> */}
      </div>
    </Fragment>
  );
}

export default Blog1DescriptionPage;
